/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_SuppressInputs */

const cs_clients_comm_suppress = /** @type {(inputs: Clients_Comm_SuppressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokovat adresu`)
};

const en_clients_comm_suppress = /** @type {(inputs: Clients_Comm_SuppressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppress address`)
};

/**
* | output |
* | --- |
* | "Suppress address" |
*
* @param {Clients_Comm_SuppressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_suppress = /** @type {((inputs?: Clients_Comm_SuppressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_SuppressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_suppress(inputs)
	return cs_clients_comm_suppress(inputs)
});